import { render, staticRenderFns } from "./InvMng.vue?vue&type=template&id=a371a028&scoped=true&"
import script from "./InvMng.vue?vue&type=script&lang=js&"
export * from "./InvMng.vue?vue&type=script&lang=js&"
import style0 from "./InvMng.vue?vue&type=style&index=0&id=a371a028&lang=css&scoped=true&"
import style1 from "./InvMng.vue?vue&type=style&index=1&id=a371a028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a371a028",
  null
  
)

export default component.exports